import { render } from "./RedeemButton.vue?vue&type=template&id=7adfe0d8&scoped=true"
import script from "./RedeemButton.vue?vue&type=script&lang=js"
export * from "./RedeemButton.vue?vue&type=script&lang=js"

import "./RedeemButton.vue?vue&type=style&index=0&id=7adfe0d8&lang=scss&scoped=true"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7adfe0d8"]])

export default __exports__